import React, {Fragment, useEffect, useState} from 'react';
import {Col, Button} from 'react-bootstrap';
import styles from './SelectTheme.module.scss';
import {useRecoilState} from 'recoil';
import {Mode} from '../../recoil/atoms';
import {ThemeToggler} from 'gatsby-plugin-dark-mode';

const SelectTheme = () => {

    const [mode, setMode] = useRecoilState(Mode)
    const [remember, setRemember] = useState(false)

    useEffect(()=>{
        setRemember(localStorage.getItem("remember"))
        if(!localStorage.getItem("theme")){
            setMode('dark')
        }
    },[setMode])

    const handlerMode = (toggleTheme, theme) => {
        toggleTheme(theme)
        setMode(theme)
    }

    const closeTooltip = () => {
        document.querySelector('#Tooltip').style.animation = 'fade-out-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both';
        let key = "remember"
        localStorage.setItem(key, "true")
        setRemember(true)
    };

    return (
        <Fragment >
            {remember ? null : 
                (   <div className={styles.Tooltip} id='Tooltip'>
                        <Button className={styles.Close} onClick={closeTooltip}><span>&times;</span></Button>
                        <p className={styles.Title}>Diseñamos nuestro sitio para <br/>que lo navegues a tu gusto.</p>
                        <div className={styles.Paragraph}>
                            <p>Elige entre Dark / Light Mode.</p>
                            <p>Lo podes cambiar más tarde</p>
                        </div>
                        <div className={styles.Pick}/>
                    </div>
             )}
            <ThemeToggler>
                {({theme, toggleTheme}) => {
                    if(!localStorage.getItem("theme")){
                        toggleTheme('dark')
                    }
                    return (
                    <Col xs='auto' className={styles.ColButtons}>
                        <Button active={mode === 'dark' ? true : false} 
                                onClick={e => handlerMode(toggleTheme, 'dark')}
                                className={styles.Button}>dark mode</Button>
                        <span className={styles.SeparatorButton}>&bull;</span>
                        <Button active={mode === 'light' ? true : false} 
                                onClick={e => handlerMode(toggleTheme, 'light')}
                                className={styles.Button}>light mode</Button>
                    </Col>
                )}}
            </ThemeToggler>
        </Fragment>
    );

}

export default SelectTheme
